var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "cart__delivery-notice" }, [
        _vm._v(
          "\n        При сумме заказа с учетом скидок от " +
            _vm._s(_vm.freeDeliverySum) +
            " руб. доставка 2–14 руб. в зависимости от региона\n    "
        )
      ]),
      _vm._v(" "),
      _vm.outletBasketTypes.length > 1
        ? _c("div", { staticClass: "cart__outlet-notice" }, [
            _vm._v(
              "\n        В корзине есть товары из раздела Outlet. Эти товары будут помещены в отдельный заказ.\n    "
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.deleteNotAvailable.length > 0
        ? _c(
            "div",
            { staticClass: "cart__outlet-notice" },
            [
              _vm._v("\n      Товары закончились и были удалены\n      "),
              _vm._l(_vm.deleteNotAvailable, function(deleteItem) {
                return _c("div", { staticClass: "cart__outlet-notice__item" }, [
                  _vm._v(_vm._s(deleteItem))
                ])
              })
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.basketItems.length
        ? [
            _vm._l(_vm.outletBasketTypes, function(outlet, index) {
              return _c("basket-items-list", {
                key: index,
                attrs: {
                  freeDeliverySum: _vm.freeDeliverySum,
                  outlet: outlet,
                  index: index + 1,
                  "show-title": _vm.outletBasketTypes.length > 1,
                  "show-coupons": outlet <= 0
                }
              })
            }),
            _vm._v(" "),
            _c("div", { staticClass: "cart-total" }, [
              _c("div", { staticClass: "cart-total__wrapper" }, [
                _c("div", { staticClass: "cart-total__block" }, [
                  _c("p", { staticClass: "cart-total__caption" }, [
                    _vm._v("Сумма заказа")
                  ]),
                  _vm._v(" "),
                  _c("p", {
                    staticClass: "cart-total__price",
                    domProps: {
                      innerHTML: _vm._f("price")(_vm.total.basePrice)
                    }
                  })
                ]),
                _vm._v(" "),
                _c(
                  "svg",
                  { staticClass: "icon icon--circle_minus cart-total__minus" },
                  [_c("use", { attrs: { "xlink:href": "#icon-circle_minus" } })]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "cart-total__block" }, [
                  _c("p", { staticClass: "cart-total__caption" }, [
                    _vm._v("Скидка")
                  ]),
                  _vm._v(" "),
                  _c(
                    "svg",
                    {
                      staticClass:
                        "icon icon--circle_minus cart-total__minus-mobile"
                    },
                    [
                      _c("use", {
                        attrs: { "xlink:href": "#icon-circle_minus" }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("p", {
                    staticClass: "cart-total__price",
                    domProps: { innerHTML: _vm._f("price")(_vm.total.discount) }
                  })
                ]),
                _vm._v(" "),
                _c(
                  "svg",
                  {
                    staticClass: "icon icon--circle_equals cart-total__equals"
                  },
                  [
                    _c("use", {
                      attrs: { "xlink:href": "#icon-circle_equals" }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "p",
                  { staticClass: "cart-total__caption cart-total__separate" },
                  [_vm._v("Итого")]
                ),
                _vm._v(" "),
                _c("p", {
                  staticClass: "cart-total__sum cart-total__separate",
                  domProps: { innerHTML: _vm._f("price")(_vm.total.totalPrice) }
                })
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "cart__btn-container" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn--blue cart__btn",
                  attrs: { type: "button", disabled: _vm.isDisableBtn },
                  on: {
                    click: function($event) {
                      return _vm.setCurrentTab("basket-order")
                    }
                  }
                },
                [_vm._v("\n                Продолжить\n            ")]
              )
            ])
          ]
        : _c("div", [
            _c("div", { staticClass: "cart__empty-message" }, [
              _c(
                "svg",
                { staticClass: "icon icon--cart cart__empty-message-icon" },
                [_c("use", { attrs: { "xlink:href": "#icon-cart" } })]
              ),
              _vm._v(" "),
              _c("p", { staticClass: "cart__empty-message-text" }, [
                _vm._v("Ваша корзина пуста")
              ])
            ])
          ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }